/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestCloudAccountCredentialsRequest
 */
export interface TestCloudAccountCredentialsRequest {
    /**
     * 
     * @type {string}
     * @memberof TestCloudAccountCredentialsRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TestCloudAccountCredentialsRequest
     */
    provider?: TestCloudAccountCredentialsRequestProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof TestCloudAccountCredentialsRequest
     */
    accessId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestCloudAccountCredentialsRequest
     */
    secret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestCloudAccountCredentialsRequest
     */
    tenant?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestCloudAccountCredentialsRequest
     */
    subscription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestCloudAccountCredentialsRequest
     */
    endpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestCloudAccountCredentialsRequest
     */
    mountCredentialsManagement?: TestCloudAccountCredentialsRequestMountCredentialsManagementEnum;
}

/**
* @export
* @enum {string}
*/
export enum TestCloudAccountCredentialsRequestProviderEnum {
    Azure = 'azure',
    Aws = 'aws',
    Backblaze = 'backblaze',
    Gcloud = 'gcloud'
}/**
* @export
* @enum {string}
*/
export enum TestCloudAccountCredentialsRequestMountCredentialsManagementEnum {
    Null = 'null',
    Share = 'share',
    Token = 'token'
}

export function TestCloudAccountCredentialsRequestFromJSON(json: any): TestCloudAccountCredentialsRequest {
    return TestCloudAccountCredentialsRequestFromJSONTyped(json, false);
}

export function TestCloudAccountCredentialsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestCloudAccountCredentialsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'accessId': !exists(json, 'access_id') ? undefined : json['access_id'],
        'secret': !exists(json, 'secret') ? undefined : json['secret'],
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'subscription': !exists(json, 'subscription') ? undefined : json['subscription'],
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'mountCredentialsManagement': !exists(json, 'mount_credentials_management') ? undefined : json['mount_credentials_management'],
    };
}

export function TestCloudAccountCredentialsRequestToJSON(value?: TestCloudAccountCredentialsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'provider': value.provider,
        'access_id': value.accessId,
        'secret': value.secret,
        'tenant': value.tenant,
        'subscription': value.subscription,
        'endpoint': value.endpoint,
        'mount_credentials_management': value.mountCredentialsManagement,
    };
}


